module.exports = __webpack_public_path__ + "img/noc.3ea3b798.png";